import { render, staticRenderFns } from "./DadataInput.vue?vue&type=template&id=04dd1066"
import script from "./DadataInput.vue?vue&type=script&lang=js"
export * from "./DadataInput.vue?vue&type=script&lang=js"
import style0 from "./DadataInput.vue?vue&type=style&index=0&id=04dd1066&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports